document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('details');

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector('[data-summary]');
    if (!summary) return; // Skip if no summary element found

    const icon = summary.querySelector('[data-icon]');
    if (!icon) return; // Skip if no icon element found

    // Set initial icon state
    if (accordion.hasAttribute('open')) {
      icon.textContent = '-';
    } else {
      icon.textContent = '+';
    }

    summary.addEventListener('click', function (e) {
      // Allow native toggle first
      setTimeout(() => {
        // Close all others
        accordions.forEach((item) => {
          if (item !== accordion) {
            item.removeAttribute('open');
            const otherIcon = item.querySelector('[data-icon]');
            if (otherIcon) otherIcon.textContent = '+';
          }
        });

        // Update current icon
        if (accordion.hasAttribute('open')) {
          icon.textContent = '-';
        } else {
          icon.textContent = '+';
        }
      }, 10);
    });
  });
});
